/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CashExposureType } from './CashExposureType';
import {
    CashExposureTypeFromJSON,
    CashExposureTypeFromJSONTyped,
    CashExposureTypeToJSON,
} from './CashExposureType';
import type { ConvictionAllocationType } from './ConvictionAllocationType';
import {
    ConvictionAllocationTypeFromJSON,
    ConvictionAllocationTypeFromJSONTyped,
    ConvictionAllocationTypeToJSON,
} from './ConvictionAllocationType';
import type { GrowthAllocationType } from './GrowthAllocationType';
import {
    GrowthAllocationTypeFromJSON,
    GrowthAllocationTypeFromJSONTyped,
    GrowthAllocationTypeToJSON,
} from './GrowthAllocationType';
import type { SecuredAllocationType } from './SecuredAllocationType';
import {
    SecuredAllocationTypeFromJSON,
    SecuredAllocationTypeFromJSONTyped,
    SecuredAllocationTypeToJSON,
} from './SecuredAllocationType';
import type { UnmanagedAllocationType } from './UnmanagedAllocationType';
import {
    UnmanagedAllocationTypeFromJSON,
    UnmanagedAllocationTypeFromJSONTyped,
    UnmanagedAllocationTypeToJSON,
} from './UnmanagedAllocationType';

/**
 * 
 * @export
 * @interface AllocationTypesInner
 */
export interface AllocationTypesInner {
}

/**
 * Check if a given object implements the AllocationTypesInner interface.
 */
export function instanceOfAllocationTypesInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AllocationTypesInnerFromJSON(json: any): AllocationTypesInner {
    return AllocationTypesInnerFromJSONTyped(json, false);
}

export function AllocationTypesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllocationTypesInner {
    return json;
}

export function AllocationTypesInnerToJSON(value?: AllocationTypesInner | null): any {
    return value;
}

